<template>
  <v-navigation-drawer
    :permanent="$vuetify.breakpoint.mdAndUp || timeNav != 1 ? true : false"
    app
    :disable-resize-watcher="true"
    :disable-route-watcher="true"
    :expand-on-hover="true"
    v-model="sideNav"
    :id="'marketplace_sidenav_drawer'"
  >
    <v-app-bar color="accent" dark text :collapse-on-scroll="true">
      <v-app-bar-nav-icon @click="toogleSideNav"></v-app-bar-nav-icon>

      <v-toolbar-title class="hidden-xs-only" height="10">
        <router-link to="/" tag="span" style="cursor:pointer">
          OlympianGuru
        </router-link>
      </v-toolbar-title>
    </v-app-bar>
    <v-divider></v-divider>
    <!-- Side Navbar Links -->
    <v-list>
      <v-list-group
        v-for="item in sideNavItems.filter(item => +item.show)"
        :key="item.title"
        :prepend-icon="item.icon"
        :to="item.link"
        no-action
        :color="item.color"
        :id="'marketplace_' + item.title"
      >
        <!-- + sign converts from string to int -->
        <v-list-item slot="activator">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-for="subItem in item.items"
          :key="subItem.title"
          :to="item.link + subItem.link"
          :id="'marketplace_sub_' + subItem.title"
        >
          <v-list-item-action>
            <v-icon color="blue">{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title color="indigo">{{
              subItem.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SideNavbar",
  data() {
    return {
      sideNav: false,
      timeNav: null,
      mini: true
    };
  },
  computed: {
    ...mapGetters(["loading", "user"]),
    sideNavState: {
      get() {
        return this.sideNav;
      },
      set(value) {
        return value;
      }
    },
    sideNavItems() {
      return [
        {
          icon: "store",
          title: "Products",
          link: "/shop",
          show: 1,
          color: "green",
          items: [{ icon: "shop", title: "Shop All", link: "/shop_list" }]
        },
        {
          icon: "precision_manufacturing",
          title: "Vendors",
          link: "/vendors",
          show: 1,
          color: "green",
          items: [
            {
              icon: "precision_manufacturing",
              title: "Vendors",
              link: "/vendor"
            }
          ]
        },
        {
          icon: "create",
          title: "Future",
          link: "/signup",
          show: 0,
          items: [
            {
              icon: "lock_open",
              title: "Sign-In",
              link: "/signin"
            }
          ]
        },
        {
          icon: "admin_panel_settings",
          title: "Admin",
          link: "/admin",
          show: `${this.isUserAdmin()}`,
          items: [
            {
              icon: "supervised_user_circle",
              title: "Users",
              link: "/user_list"
            }
          ]
        }
      ];
    },
    filteredSideNavItems() {
      return this.sideNavItems.filter(item => +item.show);
    }
  },
  methods: {
    isUserAdmin: function() {
      if (this.user && this.user.role === "Administrator") {
        return 1;
      }
    },
    toogleSideNav() {
      this.sideNav = !this.sideNav;
    }
  }
};
</script>

<style scoped></style>
